/**
 * Firebase client initialization for the admin portal.
 *
 * Mirrors the invitation user-app frontend so both SPAs share the same
 * Firebase project — there is one identity provider across the platform.
 * Backend RBAC (User.role = ADMIN | SUPER_ADMIN) is what gates the admin
 * APIs; Firebase only proves who the user is.
 *
 * All values are public (Firebase web config is not secret) but still read
 * from VITE_ env vars so each environment points at its own project.
 */

import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  setPersistence,
} from 'firebase/auth';

const isBypass = import.meta.env.VITE_DEV_AUTH_BYPASS === 'true';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || (isBypass ? 'dummy-api-key' : ''),
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || (isBypass ? 'dummy-auth-domain' : ''),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || (isBypass ? 'dummy-project-id' : ''),
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || (isBypass ? 'dummy-storage-bucket' : ''),
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || (isBypass ? 'dummy-sender-id' : ''),
  appId: import.meta.env.VITE_FIREBASE_APP_ID || (isBypass ? 'dummy-app-id' : ''),
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

void setPersistence(auth, browserLocalPersistence);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
